var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div id=\"beamerOverlay\" ng-class=\"{show: $ctrl.show}\" ng-click=\"$ctrl.close()\">\n<div id=\"beamerContainer\">\n<iframe id=\"beamerFrame\" aria-label=\"Beamer widget\" title=\"Beamer\" allowfullscreen sandbox=\"allow-scripts allow-popups allow-forms allow-top-navigation allow-same-origin\" ng-class=\"{left: $ctrl.show}\"></iframe>\n</div>\n</div>\n";
var id1="components/lbBeamer/lbBeamer.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbBeamer/lbBeamer.html
// module id = 1693
// module chunks = 5